import {
  Button,
  Greyscale,
  ScreenSize,
  SecondaryColor,
  Tag as AriesTag,
} from 'glints-aries';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const ItemWrapper = styled.div`
  margin-right: 8px;
  margin-bottom: 8px;
`;

export const SearchTypeLabel = styled.span`
  font-size: 12px;
  color: ${Greyscale.grey};
  @media (min-width: ${ScreenSize.desktopS}px) {
    font-size: 14px;
  }
`;

export const SearchKeywordLabel = styled.span`
  font-size: 12px;
  color: ${Greyscale.black};
  margin-left: 4px;
  text-transform: capitalize;
  @media (min-width: ${ScreenSize.desktopS}px) {
    font-size: 14px;
  }
`;

export const LinkButton = styled(Button).attrs({ variant: 'link' })`
  font-size: 12px;
  @media (min-width: ${ScreenSize.desktopS}px) {
    font-size: 14px;
  }
`;

export const Tag = styled(AriesTag).attrs({ outline: true })`
  border: solid 1px ${Greyscale.lightgrey};
  font-size: 12px;
  @media (min-width: ${ScreenSize.desktopS}px) {
    font-size: 14px;
  }

  .tag-content {
    padding: 4px 12px;
    @media (min-width: ${ScreenSize.desktopS}px) {
      padding: 5px 15px;
    }
  }

  svg {
    color: ${Greyscale.devilsgrey};
    width: 10px;
    height: 10px;
    margin-right: 8px;
    @media (min-width: ${ScreenSize.desktopS}px) {
      width: 14px;
      height: 14px;
      padding-bottom: 2.5px;
    }
  }

  :hover {
    background-color: ${SecondaryColor.actionblue};
    color: ${Greyscale.white};

    label {
      svg {
        background-color: ${SecondaryColor.actionblue};
        color: ${Greyscale.white};
      }
      span {
        background-color: ${SecondaryColor.actionblue};
        color: ${Greyscale.white};
      }
    }
  }
`;

export const SkeletonTagWrapper = styled.div`
  display: flex;
  align-items: center;
  border: solid 1px ${Greyscale.lightgrey};
  border-radius: 16px;
  padding: 4px 12px;

  @media (min-width: ${ScreenSize.desktopS}px) {
    padding: 5px 15px;
  }

  svg {
    color: ${Greyscale.lightgrey};
    width: 10px;
    height: 10px;
    margin-right: 8px;
    @media (min-width: ${ScreenSize.desktopS}px) {
      width: 14px;
      height: 14px;
      padding-bottom: 2.5px;
    }
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
  }
`;
